import styled from "styled-components";
export const DataTableContainer = styled.div.withConfig({
  displayName: "data-tablestyles__DataTableContainer",
  componentId: "sc-2z73zz-0"
})(["", ""], {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center"
});
export const DataTableContentContainer = styled.table.withConfig({
  displayName: "data-tablestyles__DataTableContentContainer",
  componentId: "sc-2z73zz-1"
})(["", " tr{", " th,td{height:3rem;&:first-child{", "}&:last-child{", "}}th{border-bottom:2px solid rgba(0,0,0,0.12);&.data-table__header--sorted{", " .data-table__header__sorter{", "}}.data-table__header{&--text{", "}&__sorter{", "}}}td{border-bottom:1px solid rgba(0,0,0,0.12);}}"], {
  display: "table",
  tableLayout: "auto",
  width: "100%",
  boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.20), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
  marginBottom: "1rem"
}, {
  display: "table-row",
  width: "100%"
}, {
  paddingLeft: "1rem"
}, {
  paddingRight: "1rem"
}, {
  fontWeight: "900"
}, {
  opacity: "1"
}, {
  textTransform: "uppercase",
  fontWeight: "700"
}, {
  opacity: "0",
  marginLeft: "0.25rem"
});
export const DataTableHeaderContainer = styled.thead.withConfig({
  displayName: "data-tablestyles__DataTableHeaderContainer",
  componentId: "sc-2z73zz-2"
})([""]);
function textJustifyContent(textAlign) {
  switch (textAlign) {
    case "center":
      return {
        textAlign: "center"
      };
    case "end":
      return {
        textAlign: "right"
      };
    case "start":
    default:
      return {
        textAlign: "left"
      };
  }
}
export const DataTableThContainer = styled.th.withConfig({
  displayName: "data-tablestyles__DataTableThContainer",
  componentId: "sc-2z73zz-3"
})(["", " ", " ", ";", ";&:hover .data-table__header__sorter{", "}"], {
  display: "table-cell"
}, ({
  clickable
}) => clickable && {
  cursor: "pointer"
}, ({
  width
}) => width && `width: ${width}`, ({
  textAlign
}) => textJustifyContent(textAlign), {
  opacity: "1",
  fontWeight: "900"
});
export const DataTableBodyContainer = styled.tbody.withConfig({
  displayName: "data-tablestyles__DataTableBodyContainer",
  componentId: "sc-2z73zz-4"
})([""]);
export const DateTableTdContainer = styled.td.withConfig({
  displayName: "data-tablestyles__DateTableTdContainer",
  componentId: "sc-2z73zz-5"
})(["", " ", ";", ";"], {
  display: "table-cell"
}, ({
  width
}) => width && `width: ${width}`, ({
  textAlign
}) => textJustifyContent(textAlign));
